// 团队接口信息
import http from "@/utils/request";

/** @description 团队套餐列表 */
export const teamPackageList = (params: any) => http.get(`/team/package`, params);

/** @description 团队详情 */
export const teamDetailApi = () => http.get(`/team/detail`);

/** @description 团队权益流水分页数据 */
export const equityFlowPage = (params: any, pathParams?: string) => {
  const _params = { ...params };
  delete _params.types;
  return http.get(`/team/package/benefit/flow${pathParams || ""}`, _params);
};
